
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from './../services/http.service';
import { GlobalService } from './global.service';
import { Globals } from '../models/globals.model';
import { AlertComponent } from '../common/alert/alert.component';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MLService {

  apiUri: string;
  graphUri: string;

  constructor(private readonly httpService: HttpService, private readonly globals: Globals, private readonly http: HttpClient, private readonly globalsService: GlobalService,
    public router: Router) {
    this.apiUri = this.globals.config.platformApi_client_resourceUri;
    this.graphUri = this.globals.config.graphApi_client_resourceUri;
  }

  getToken() {
    return this.http.get(this.apiUri + this.globalsService.xsrfTokenUrl);
  }
  
  getUseCasesUrl() {
    return this.http.get(this.apiUri + this.globalsService.useCaseUrlsApi);
  }

  redirectTo(url) {
    window.location.href = url;
  }

}